import Vue from "vue"
import {updateField} from "vuex-map-fields"
import {getField} from "vuex-map-fields"

export const actions = {
    openPanel({state}, activityType = 'normal') {
        if (state.panel_open) return Vue.noty.error('Note is already open. Please close it to open a new one.')
        state.panel_open = true
        state.type = activityType
    },
    closePanel({state}) {
        state.panel_open = false
    },
    openAppointmentPanel({state}) {
        if (state.panel_open) return Vue.noty.error('Task Panel is already open. Please close it to open a new one.')
        state.panel_open = true
        state.type = 'appointment'
    },
}

export const getters = {
    getField,
}

export const mutations = {
    updateField,
}

export const state = () => ({
    panel_open: false,
    type: 'normal'
})
